import { useCallback } from 'react';

import { useRequiredParam } from '@/hooks/useRequiredParam';
import { useDispositiveProvisionSuggestionsContext } from '@/modules/aiDP/context/dispositiveProvisionSuggestions.context';
import { RegenerateAISuggestionsMenuItem } from '@/modules/aiSuggestions/components/RegenerateAISuggestionsMenuItem';
import { useEntitySuggestionsContext } from '@/modules/aiSuggestions/context/EntitySuggestions.context';
import { useEntityDetailsContext } from '@/modules/entities/contexts/entityDetails/entityDetails.context';

export function RegenerateEntitySuggestionsV2Button() {
  const { entityId } = useEntityDetailsContext();
  const householdId = useRequiredParam('householdId');
  const { refetchSuggestions } = useEntitySuggestionsContext();
  const { refetchSuggestions: refetchDPSuggestions } =
    useDispositiveProvisionSuggestionsContext();

  const handleCompleted = useCallback(() => {
    refetchSuggestions();
    if (entityId) {
      refetchDPSuggestions(entityId);
    }
  }, [entityId, refetchDPSuggestions, refetchSuggestions]);

  if (!entityId) return null;

  return (
    <RegenerateAISuggestionsMenuItem
      targetId={entityId}
      householdId={householdId}
      onCompleted={handleCompleted}
      confirmation={{
        heading:
          'Are you sure you want to regenerate AI suggestions for this entity?',
        body: 'Regenerating suggestions will remove existing suggestions. New suggestions will be generated from available documents. Holding suggestions will not be regenerated.',
      }}
    />
  );
}
